/* My Coupons - code copy interaction */
(function () {
  'use strict';

  function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    // Fallback for older browsers
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
        resolve();
      } catch (err) {
        reject(err);
      } finally {
        document.body.removeChild(ta);
      }
    });
  }

  function showCopiedFeedback(button) {
    var originalHTML = button.innerHTML;
    button.classList.add('online-coupon-card__code-copy--copied');
    button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
    setTimeout(function () {
      button.classList.remove('online-coupon-card__code-copy--copied');
      button.innerHTML = originalHTML;
    }, 1500);
  }

  function init() {
    var buttons = document.querySelectorAll('[data-copy-code]');
    buttons.forEach(function (btn) {
      if (btn.dataset.initialized === '1') return;
      btn.dataset.initialized = '1';
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-copy-code');
        if (!code) return;
        copyToClipboard(code).then(function () {
          showCopiedFeedback(btn);
        }).catch(function (err) {
          if (window.console) console.warn('[my-coupons] copy failed:', err);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();